import dynamic from "next/dynamic";
import LoadingAnimationIcon from "components/animations/loading_animation.json";

const LottiePlayer = dynamic(
  () => import("components/animations/LottiePlayer"),
  {
    ssr: false,
  },
);

export default function LoadingSpotlightLottie({ lottieClassName }) {
  return (
    <div className="flex items-center justify-center">
      <LottiePlayer
        lottieAnimation={LoadingAnimationIcon}
        className={lottieClassName}
      />
    </div>
  );
}
